/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-02-06 11:51:30 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-09-11 11:31:59
 */

/**
 * 
 * @param {LstEntry[]} entries 
 * @param {Set<String>} columns 
 */
export function buildLst(entries, columns) {
    const keys = new Set(columns);
    keys.delete("$value");
    const fields = Array.from(keys);
    return entries.map(entry => {
        if (!entry.$value) {
            return undefined;
        }
        return entry.$value.trimRight() + fields.map(key => entry[key] ? `:${key}=${entry[key].trimRight()}`: "").join("");
    }).filter(e => e).join("\n") + "\n";
}

export function getEmptyFeatures(entries, columns) {
    const keys = new Set(columns);
    keys.delete("$value");

    for (const entry of entries) {
        for (const field of keys) {
            entry[field] && keys.delete(field);
        }
    }
    return Array.from(keys);
}

export function getColumns(items) {
    const columns = new Set();
    for (const item of items) {
        Array.from(Object.keys(item)).forEach(key => columns.add(key));
    }
    return columns;
}

export const validator = {
    defValue(value) {
        return !/[:]/.test(value);
    },
    lstValue(value) {
        return !/[:]/.test(value);
    },
    lstFeature(value) {
        return !/[:=]/.test(value);
    }
}

export function calculateDuplicateEntries(entries) {
    let duplicatesCount = 0;
    const set = new Set();
    for (const entry of entries) {
        if (set.has(entry.$value)) {
            duplicatesCount++;
        }
        set.add(entry.$value);
    }
    return duplicatesCount;
}

import { call, put, take } from 'redux-saga/effects';

import api from "services";
import * as actionTypes from 'constants/ActionTypes';

export function *loadDefFile() {
    const response = yield call(api.loadGazetteerIndex);
    
    return [response.headers["x-version"], response.data];
}

export function *loadLstFile(filename) {
    const response = yield call(api.loadGazetteer, encodeURIComponent(filename));

    const lines = getLines(response.data);
    return [response.headers["x-version"], fastMap(lines, parseLstLine)];
}

export function *saveLst(filename, version, text) {
    try {
        const response = yield call(api.saveGazetteer, encodeURIComponent(filename), version, text);
        yield notify(`Lst ${filename} file successfully saved`);
        return response.headers["x-version"];
    }
    catch (err) {
        yield notify(new Error((err.response || {}).data));
    }
}

export function *saveDef(version, items) {
    try {
        const response = yield call(api.saveGazetteerIndex, version, items);
        yield notify("Def file successfully saved");
        
        return [response.headers["x-version"], response.data];
    }
    catch (err) {
        yield notify(new Error((err.response || {}).data));
    }
}

export function *removeDuplicates(filename) {
    try {
        const response = yield call(api.removeGazetteerDuplicates, encodeURIComponent(filename));

        const { beforeItemsCount, afterItemsCount } = response.data;
        yield notify(`${beforeItemsCount - afterItemsCount} duplicates successfully removed from gazetteer ${filename}`);
    }
    catch (err) {
        yield notify(new Error((err.response || {}).data));
    }
}

function *notify(obj) {
    if (obj instanceof Error) {
        if (!obj.message) {
            console.error(obj);
        }
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: 'Error: ' + obj.message || "unknown",
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });
    }
    else {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: obj,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });
    }
}

function getLines(text) {
    return text.split(/\r\n|\r|\n/);
}

const featureMatcher = /([^=]+)=([^=]+)/i;

const lstLineHandler = (matched, value) => {
    if (matched === 0) {
        return ["$value", value];
    }
    const match = featureMatcher.exec(value);
    if (match) {
        return [match[1], match[2]];
    }
    return [undefined];
};

/**
 * 
 * @param {String} line 
 */
function parseLstLine(line) {
    return parseGateDicts(line, lstLineHandler);
}

/**
 * 
 * @param {String} line 
 */
function parseGateDicts(line, resolver) {
    const result = {};
    
    let matched = 0;
    let current = "";
    // c.clear();
    const length = line.length;
    for (let i = 0; i < length; i++) {
        if (line[i] === ":") {
            const [target, value] = resolver(matched++, current);
            // const [target, value] = resolver(matched++, c.toString());
            if (target !== undefined) {
                result[target] = value;
            }
            current = "";
            // c.clear();
        }
        else {
            current += line[i];
            // c.append(line[i]);
        }
    }
    if (current.length > 0) {
    // if (c.size > 0) {
        const [target, value] = resolver(matched++, current);
        // const [target, value] = resolver(matched++, c.toString());
        if (target !== undefined) {
            result[target] = value;
        }
    }

    return result;
}

/**
 * Fast version of Array::map without checks for holes and mapper context
 */
function fastMap(arr, fn) {
    const length = arr.length;
    const result = new Array(length);
    for(let i = 0; i < length; i++) {
        result[i] = fn(arr[i]);
    }
    return result;
}




// WEBPACK FOOTER //
// ./app/components/Gazetteers/service/index.js